import React, { FC } from 'react';
import { Button } from 'antd';

import { Typography } from 'app/components/domain/typography';
import { i18n } from 'app/i18n';
import { AccountSwitchLink, AddressSwitchLink } from 'app/components/domain/switch-link';
import { ResponsiveTypography } from 'app/components/common/typography';
import { BREAKPOINTS } from 'app/styles/breakpoints';

import styles from './no-inflight-orders.module.scss';

export const NoInflightOrders: FC = () => (
    <div className={styles.noInflightOrders}>
        <div className={styles.container}>
            <Typography className={styles.title} variant="heading" component="h1">
                {i18n.noInflightOrders.title}
            </Typography>
            <ResponsiveTypography
                className={styles.text}
                variant="subtitle3"
                component="p"
                rules={{
                    [BREAKPOINTS.TABLET_LANDSCAPE]: {
                        subtitle3: 'body1',
                    },
                    [BREAKPOINTS.MOBILE]: {
                        subtitle3: 'body2',
                    },
                }}
            >
                {i18n.noInflightOrders.noActiveOrders}
            </ResponsiveTypography>
            <div className={styles.switchLinksContainer}>
                <AccountSwitchLink />
                <AddressSwitchLink />
            </div>
            <Button type="primary" className={styles.button}>
                {i18n.noInflightOrders.button.label}
            </Button>
        </div>
    </div>
);
